<script setup lang="ts">
import { ref } from "vue"
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogTitle,
} from "@/components/ui/dialog"
import { Separator } from "@/components/ui/separator"
import { Button } from "@/components/ui/button"
import GlowIcon from "@/components/af/GlowIcon/GlowIcon.vue"
import { storeToRefs } from "pinia"
import { useI18nStore } from "@/stores/i18n"
import { useConfigStore } from "@/stores/config"
import { useSessionStorage } from "@/helpers/useSessionStorage"

const configStore = useConfigStore()
const { currentLocale } = storeToRefs(useI18nStore())
const { getSessionItem } = useSessionStorage()

function onValid() {
  let url = `${configStore.urls.integration_url}/${getSessionItem("iframe_token")}/assessment?v=af`
  if (getSessionItem("version")) {
    url = `${configStore.urls.integration_url_v1}/${getSessionItem("iframe_token")}?v=af`
  }

  if (getSessionItem("goto_param")) {
    url += `&id=${getSessionItem("goto_param")}`
  }
  if (getSessionItem("target_uuid")) {
    url += `&target_uuid=${getSessionItem("target_uuid")}`
  }
  if (getSessionItem("sharepool_uuid")) {
    url += `&sharepool_uuid=${getSessionItem("sharepool_uuid")}`
  }
  if (getSessionItem("redirect_url")) {
    url += `&redirect_url=${getSessionItem("redirect_url")}`
  }
  if (getSessionItem("version")) {
    url += `&version=${getSessionItem("version")}`
  }

  window.open(url, "_blank")
}

const isOpen = ref(true)
</script>

<template>
  <Dialog v-model:open="isOpen">
    <DialogContent
      :closable="false"
      :class="
        [
          'border-afbranding-border bg-white',
          currentLocale.iso_code_639 === 'ar-SA' && 'arabic',
        ].join(' ')
      "
    >
      <GlowIcon class="mx-auto" icon="fa-thin fa-door-open" />

      <div class="mx-auto w-48">
        <Separator class="bg-grey-lighten-3" />
      </div>

      <DialogTitle class="text-center text-afbranding-heading">
        {{ $t("assessment.iframe.blocked.title") }}
      </DialogTitle>

      <DialogDescription class="text-center text-afbranding-text">
        {{ $t("assessment.iframe.blocked.body") }}
      </DialogDescription>

      <div
        class="-mx-5 flex flex-col items-center justify-center gap-4 px-5 lg:m-0 lg:flex-row lg:px-0"
      >
        <Separator class="bg-grey-lighten-3 lg:hidden" />
        <div class="flex w-full flex-col-reverse gap-4 md:w-auto md:flex-row">
          <Button @click="onValid">{{
            $t("assessment.iframe.blocked.cta")
          }}</Button>
        </div>
      </div>
    </DialogContent>
  </Dialog>
</template>
